import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import { useCallback, useEffect, useState } from "react";
import styles from "./index.module.scss";

// Thumbnails overlap (first on top); click opens a popup where prev/next wrap around in a loop.
const ImageStack = ({ images = [] }) => {
  const [current, setCurrent] = useState(null);
  const total = images.length;
  const isOpen = current !== null;

  const go = useCallback((step) => setCurrent((prev) => (prev + step + total) % total), [total]);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "ArrowLeft") go(-1);
      if (e.key === "ArrowRight") go(1);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen, go]);

  if (!total) return null;

  return (
    <>
      <div className={styles.stack}>
        {images.map((src, idx) => (
          <img
            key={`${src}-${idx}`}
            className={styles.thumb}
            style={{ zIndex: total - idx }}
            src={src}
            alt=""
            onClick={() => setCurrent(idx)}
          />
        ))}
      </div>
      <Modal visible={isOpen} footer={null} centered width={720} onCancel={() => setCurrent(null)} destroyOnClose>
        {isOpen && (
          <div className={styles.viewer}>
            {total > 1 && <LeftOutlined className={`${styles.arrow} ${styles.left}`} onClick={() => go(-1)} />}
            <img className={styles.preview} src={images[current]} alt="" />
            {total > 1 && <RightOutlined className={`${styles.arrow} ${styles.right}`} onClick={() => go(1)} />}
            <div className={styles.counter}>
              {current + 1} / {total}
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default ImageStack;
